import { useEffect } from 'react'
import { useHistory } from 'react-router'
import { StyledSubHeader } from '../components/StyledSubHeader'
import logo from '../eye-mask.svg'

export const About = () => {

    const history = useHistory()

    useEffect(()=>{
        document.title = 'About'
    })

    return (
        <div className='flex-column about' >
            <img src={logo} alt="" style={{ width: 100, height: 70, marginTop: 10 }} />
            <h2>What is SayToMe?</h2>
            <p>SayToMe is the free, minimalistic Dateship app(Read Dateship as Dating/Friendship) where Anonymous critics is a byproduct.</p>
            <p>It is a platform where you can connect with people who are real, verified or have random critics conversations with
                 your fan followers for free.</p>
            <p>SayToMe is <span style={{ color: 'green', fontWeight: 700 }} >free</span>,
                <span style={{color: 'blue', fontWeight: 700}} > open</span> but 
                <span style={{color: 'purple', fontWeight: 800}} > private</span>.</p>
            <StyledSubHeader heading='Free' color='green' />
            <p>SayToMe is free to join and use with NO paid plans. It's premium but unpaid and evolving each day.</p>
            <StyledSubHeader heading='Open' color='blue' />
            <p>SayToMe is open to all people irrespective of anything but disrespectful behavior.
                Of course, you would need to establish trust before you are let in.</p>
            <StyledSubHeader heading='Private' color='purple' />
            <p>SayToMe is a private community as it only lets users in who have established trust with SayToMe by our verification norms.</p>
            <p>With the ever growing internet's reach and the uncountable unsafe users of it growing along, 
                it is essential to isolate and form a community of trust and genuine people.</p>
            <div style={{height: 30}} ></div>
            <div style={{fontStyle: 'italic'}} >
                <p>SayToMe has been built and developed by the community, for the community</p>
                <p>Consider it as a free alternative to all the dating, match-making apps you could think of.</p>
            </div>
            <h4 style={{marginTop: 20, color: 'purple'}} onClick={()=>history.push('/stapp/register')} >Sign Up</h4>
            <img src={logo} alt="" style={{width: 40, height: 30, marginTop: 10}} />
        </div>
    )
}